module.exports = __webpack_public_path__ + "img/errorimg.1d8d5cd5.svg";